"use strict";
/*
 * Created on 19. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Result of action on a release part.
 *
 * @author Radek Beran
 */


var ReleasePartActionResult =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleasePartActionResult, _DomainObject_1$Domai);

  /**
   * Result of action with release part.
   * @param success
   * @param categoryId release part category
   * @param errorCode
   * @param errorSubcode
   * @param conflictingUser
   * @param targetState
   */
  function ReleasePartActionResult(success, categoryId, errorCode, errorSubcode, conflictingUser, targetState) {
    var _this;

    _classCallCheck(this, ReleasePartActionResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleasePartActionResult).call(this));
    _this.success = success;
    _this.categoryId = categoryId;
    _this.errorCode = errorCode;
    _this.errorSubcode = errorSubcode;
    _this.conflictingUser = conflictingUser;
    _this.targetState = targetState;
    return _this;
  }

  return ReleasePartActionResult;
}(DomainObject_1.DomainObject);

exports.ReleasePartActionResult = ReleasePartActionResult;